import * as types from './constants';

const initialState = {
  products: [],
  loading: false,
  // Variants pulled in so far across every selected collection, so a long import can say how far
  // along it is rather than spinning silently.
  loaded_variants: 0,
  errors_api: {}
};

const actions = {
  // Get Shopify Collection Products
  [types.GET_SHOPIFY_COLLECTION_PRODUCTS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      loaded_variants: 0,
      errors_api: {}
    };

    return { ...data };
  },

  [types.SHOPIFY_COLLECTION_PRODUCTS_PROGRESS]: (state, { payload }) => {
    const data = {
      ...state,
      loaded_variants: payload.loaded
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTION_PRODUCTS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTION_PRODUCTS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTION_PRODUCTS_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
